import Parceiros from './parceiros';

export default Parceiros;